export enum HomeAway{
  Home = 'home',
  Away = 'away'
}
